(function (scope) {
  "use strict";

  /**
   * @constructor
   * @param {sculpteo.PrintController} controller
   * @param {Viewer} viewer
   * @param {Design} design
   */

  // ALL ORIENTATIN MUST BE IN THE FORM OF : "w, x, y, z"

  var PrintPartOrientationView = (scope.PrintPartOrientationView = function (
    controller,
    viewer,
    design,
    axisModelUrl
  ) {
    this.controller = controller;
    this.design = design;
    this.viewerUI = viewer.viewerUI;
    this.viewer = viewer.viewerUI.viewer;
    this.axisModelUrl = axisModelUrl;
    this.model = null;
    // we need to init only once. We can't init in the constructor because
    //the viewer is not ready. So we init part orientation when we call enabled. This var make sure we call the init only once.
    this.is_init = false;

    this.is_active = false;

    this.can_save = true;

    this.$el = $("#part-orientation-settings");

    this.modeBatchActivated = false;

    this.currentRotation = null;

    this.axis = {
      active: false,
      visible: false,
      node: null,
      bbox: null,
    };

    this.printPlate = {
      active: false,
      scene: false,
      visible: false,
      bottom: null,
      batch_size: {
        x: 20,
        y: 20,
        z: 0.0001,
      },
    };

    this.snapshotSize = {
      width: 62,
      height: 62,
    };

    this.$el.on(
      "click",
      ".tool-back-default",
      this.backToDefaultView.bind(this)
    );
    this.$el.on(
      "click",
      ".tool-back-batch-control",
      this.backToBatchView.bind(this)
    );

    this.$el.on(
      "click",
      "#part-orientation-axis-z",
      this.turnModelOn_Z_Axis.bind(this)
    );
    this.$el.on(
      "click",
      "#part-orientation-axis-y",
      this.turnModelOn_Y_Axis.bind(this)
    );
    this.$el.on(
      "click",
      "#part-orientation-axis-x",
      this.turnModelOn_X_Axis.bind(this)
    );
    this.$el.on("click", ".tool-reset", this.reset.bind(this));

    this.$el.on("click", ".tool-save", this.saveOrientation.bind(this));

    this.initAxisModel();
  });

  /**
   * if we already have an orientation we show it and use it
   * @public
   */
  PrintPartOrientationView.prototype.has_orientation = function () {
    //check if an orientation is already active;
    var op = this.design.print_operation.data;
    //set the default orientation to be the model facing the camera
    var orientation = "1,0,0,0";

    if (
      isNaN(op.orientation_w) ||
      isNaN(op.orientation_x) ||
      isNaN(op.orientation_y) ||
      isNaN(op.orientation_z) ||
      op.orientation_w == null ||
      op.orientation_x == null ||
      op.orientation_y == null ||
      op.orientation_z == null ||
      (op.orientation_w === 0 &&
        op.orientation_x === 0 &&
        op.orientation_y === 0 &&
        op.orientation_z === 0)
    ) {
      //set currentRotation
      this.currentRotation = orientation;
    } else {
      orientation = op.orientation_w + ",";
      orientation += op.orientation_x + ",";
      orientation += op.orientation_y + ",";
      orientation += op.orientation_z + ",";

      this.currentRotation = orientation;
      this.controller.updateOrientation(
        true,
        this.orientationStringToObject(this.currentRotation)
      );
      this.controller.views.tools.setEnabled(
        sculpteo.PrintToolsView.TOOLS.ORIENTATION,
        true
      );
    }
  };

  /**
   * init part orientation
   * @public
   */
  PrintPartOrientationView.prototype.init = function () {
    if (this.is_init) {
      return;
    }
    this.is_init = true;
    this.model = this.viewer.getNodesByName("model")[0];

    //apply the current rotation to the model
    var transform = this.rotationToTransform(
      this.orientationStringToObject(this.currentRotation)
    );
    if (this.model) {
      this.model.setTransform(transform);
    }
  };

  /**
   * toggle the mode batch in orientation
   * @private
   */
  PrintPartOrientationView.prototype.toggleBatchMode = function (enabled) {
    this.modeBatchActivated = enabled;

    if (this.modeBatchActivated == true) {
      $(".tool-back-batch-control").show();
    } else {
      $(".tool-back-batch-control").hide();
    }
  };

  /**
   * Back to default view
   * @private
   */
  PrintPartOrientationView.prototype.backToDefaultView = function (e) {
    this.controller.switchTool(sculpteo.PrintToolsView.TOOLS.DASHBOARD);
  };

  /**
   * Back to batch control view
   * @private
   */
  PrintPartOrientationView.prototype.backToBatchView = function () {
    this.controller.switchTool(sculpteo.PrintToolsView.TOOLS.BATCH_CONTROL);
  };

  /**
   * enable the part orientation
   * @public
   */
  PrintPartOrientationView.prototype.enabled = function () {
    this.init();

    this.viewer.setLocal(true);
    this.previousQualitySetting = this.viewer.getQuality();
    this.viewer.setQuality(1);

    this.$el.show();

    this.activateAxisModel();
    this.activatePrintPlate();
    this.defaultPosition();
  };

  /**
   * disable the part orientation
   * @public
   */
  PrintPartOrientationView.prototype.disabled = function () {
    this.$el.hide();

    this.deactivateAxisModel();
    this.deactivatePrintPlate();
    this.viewer.setQuality(this.previousQualitySetting);
  };

  /**
   * save orientation
   * @public
   */
  PrintPartOrientationView.prototype.saveOrientation = function () {
    //saved server side orientation
    this.controller
      .updateOrientation(
        true,
        this.orientationStringToObject(this.currentRotation)
      )
      .then(
        function () {
          //show overlay message
          this.controller.overlayNotify(
            sculpteo.PrintOverlayNotification.TYPE.SAVED,
            gettext("Part orientation has been saved"),
            false
          );
        }.bind(this)
      );
  };

  /**
   * Reset part orientation
   * @public
   */
  PrintPartOrientationView.prototype.reset = function () {
    //avoid issue
    if (!this.model) {
      return;
    }

    this.currentRotation = "1,0,0,0";

    var transform = this.rotationToTransform(
      this.orientationStringToObject(this.currentRotation)
    );
    this.model.setTransform(transform);

    //update orientation and show overlay notif only if there is an orientation on the model
    if (this.design.order.fixed_orientation === 1) {
      // Updates status
      var axis = { w: NaN, x: NaN, y: NaN, z: NaN };
      this.controller.updateOrientation(false, axis).then(
        function () {
          //show overlay message
          this.controller.overlayNotify(
            sculpteo.PrintOverlayNotification.TYPE.RESET,
            gettext("Part orientation has been reset"),
            false
          );
        }.bind(this)
      );
    }

    this.defaultPosition();
  };

  PrintPartOrientationView.prototype.defaultPosition = function () {
    //set the zoom to 2.5min to have all the model and plate visible
    var zoomCamera = this.viewer.getZoom();
    if (this.viewer.getZoom() < 2.5) {
      zoomCamera = 2.5;
    }
    //animate the camera to a view at 45degree
    //this.viewer.animateCamera(this.orientationStringToArray("0.85355,0.35355,0.14645,-0.35355"), undefined,zoomCamera, 400);
    this.viewer.animateCamera(
      this.orientationStringToArray("0.908,0.166,0.0741,-0.375"),
      undefined,
      zoomCamera,
      400
    );
  };

  /**
   * Function link to the button X Y Z and reset
   * @public
   */
  PrintPartOrientationView.prototype.turnModelOn_Z_Axis = function () {
    this.turnModelOnAxis("z");
  };
  PrintPartOrientationView.prototype.turnModelOn_Y_Axis = function () {
    this.turnModelOnAxis("y");
  };
  PrintPartOrientationView.prototype.turnModelOn_X_Axis = function () {
    this.turnModelOnAxis("x");
  };

  /**
   * rotate the model of 45degree in the set direction
   * @public
   */
  //use for lock the model rotation when we're animating it
  var viewerLocked = false;
  PrintPartOrientationView.prototype.turnModelOnAxis = function (direction) {
    //don't rotate if we're animating the model
    if (viewerLocked) {
      return;
    }

    // switch(direction){
    // 	case "y":
    // 		this.currentRotation = rotateY45(this.currentRotation);
    // 		break;
    // 	case "x":
    // 		this.currentRotation = rotateX45_anti(this.currentRotation);
    // 		break;
    // 	case "z":
    // 		this.currentRotation = rotateZ45_anti(this.currentRotation);
    // 		break;
    // }

    //quaternion of the model
    var q1 = this.orientationStringToObject(this.currentRotation);

    //final quaternion
    var qFinal = {};
    var q2;

    switch (direction) {
      //{w:Math.cos(Math.PI/8), x:0, y:0, z:Math.sin(Math.PI/8)};
      case "y":
        q2 = { w: 0.92387953251, x: 0, y: 0, z: 0.38268343236 };
        break;
      case "x":
        q2 = { w: 0.92387953251, x: 0.38268343236, y: 0, z: 0 };
        break;
      case "z":
        q2 = { w: 0.92387953251, x: 0, y: 0.38268343236, z: 0 };
        break;
    }

    //multiply quaternion q2 with q1
    qFinal.w = q2.w * q1.w - q2.x * q1.x - q2.y * q1.y - q2.z * q1.z;
    qFinal.x = q2.w * q1.x + q2.x * q1.w + q2.y * q1.z - q2.z * q1.y;
    qFinal.y = q2.w * q1.y - q2.x * q1.z + q2.y * q1.w + q2.z * q1.x;
    qFinal.z = q2.w * q1.z + q2.x * q1.y - q2.y * q1.x + q2.z * q1.w;

    //var transform = this.rotationToTransform(this.orientationStringToObject(this.currentRotation));
    var transform = this.rotationToTransform(qFinal);
    this.model.animateTransform(transform, 400);

    //set the currentRotation with the new quaternion calculated before
    this.currentRotation =
      qFinal.w + "," + qFinal.x + "," + qFinal.y + "," + qFinal.z;

    //locked
    viewerLocked = true;
    setTimeout(function () {
      viewerLocked = false;
    }, 400);

    //this.viewer.animateCamera(this.orientationStringToArray(rotateY90(orientViewer)), [0,0], this.viewer.getZoom(), 400);
  };

  /**
   * return an array of the set string rotation
   * @public
   */
  PrintPartOrientationView.prototype.orientationStringToArray = function (
    rotation
  ) {
    var arrayRotation = rotation.split(",");
    for (var i = arrayRotation.length - 1; i >= 0; i--) {
      arrayRotation[i] = parseFloat(arrayRotation[i]);
    }

    return arrayRotation;
  };

  /**
   * return an object of the set string rotation
   * @public
   */
  PrintPartOrientationView.prototype.orientationStringToObject = function (
    rotation
  ) {
    var objectRotation = {};
    objectRotation.w = rotation.split(",")[0];
    objectRotation.x = rotation.split(",")[1];
    objectRotation.y = rotation.split(",")[2];
    objectRotation.z = rotation.split(",")[3];

    return objectRotation;
  };

  /**
   * return a new Sculpteo3DViewerTransform3D with the set rotation
   * @public
   */
  PrintPartOrientationView.prototype.rotationToTransform = function (rotation) {
    var t = new Sculpteo3DViewerTransform3D();

    return t
      .translate(
        this.design.center.x,
        this.design.center.y,
        this.design.center.z
      )
      .x(
        t
          .rotateQ(rotation.w, rotation.x, rotation.y, rotation.z)
          .x(
            t.translate(
              -this.design.center.x,
              -this.design.center.y,
              -this.design.center.z
            )
          )
      );
  };

  /**
   * function use to load model for the viewer. Only use in orientation
   * @public
   */
  PrintPartOrientationView.prototype.loadModel = function (url, bboxCallback) {
    var id = Utils.uniqueString();
    var node = this.viewer.createNode(id);
    if (bboxCallback) {
      var bboxListener = function (minx, miny, minz, maxx, maxy, maxz) {
        bboxCallback(minx, miny, minz, maxx, maxy, maxz);
        node.removeEventListener(bboxListener);
      };
      node.addEventListener("bbox", bboxListener);
    }
    this.viewer.loadModel(url, id);
    this.viewer.getScene().appendChild(node);
    return node;
  };

  /**
   * Activate and display the axis in the viewer
   * @public
   */
  PrintPartOrientationView.prototype.activateAxisModel = function () {
    if (this.axis.active) {
      return;
    }

    this.axis.active = true;
    this.updateAxisWithCurrentDesign();
  };

  /**
   * Deactivate and hide the axis in the viewer
   * @public
   */
  PrintPartOrientationView.prototype.deactivateAxisModel = function () {
    if (!this.axis.active) {
      return;
    }
    this.axis.active = false;
    this.axis.visible = false;
    if (this.axis.node) {
      this.axis.node.detach();
    }
  };

  /**
   *  Init the axis model
   * Load the model and set the material
   */
  PrintPartOrientationView.prototype.initAxisModel = function () {
    // Wait for the viewer to be initialized before loading the axis model
    this.viewer.bind(
      "init",
      function () {
        this.axis.node = this.loadModel(
          this.axisModelUrl,
          function (minx, miny, minz, maxx, maxy, maxz) {
            this.axis.bbox = {
              min: {
                x: minx,
                y: miny,
                z: minz,
              },
              max: {
                x: maxx,
                y: maxy,
                z: maxz,
              },
              size: {
                x: maxx - minx,
                y: maxy - miny,
                z: maxz - minz,
              },
              maxd: Math.max(maxx - minx, maxy - miny, maxz - minz),
            };

            this.updateAxisWithCurrentDesign();
          }.bind(this)
        );
        // Detach it until it's needed
        this.axis.node.detach();
        this.axis.node.setMaterial("white_plastic");
        // Don't cut the axis model
        this.axis.node.setDrawMode(
          Sculpteo3DViewerSceneNode.DRAWMODE_FLAT |
            Sculpteo3DViewerSceneNode.DRAWMODE_NO_CUT
        );
      }.bind(this)
    );
  };

  /**
   * Update the axis model position depending on the current design.
   * The is placed on position calculated same as a corner on a print plate.
   */
  PrintPartOrientationView.prototype.updateAxisWithCurrentDesign = function () {
    if (!this.axis.active) {
      return;
    }

    if (this.axis.bbox == null) {
      return;
    }

    var maxd = Math.max(
      this.design.size.x,
      this.design.size.y,
      this.design.size.z
    );
    var scale = (maxd / this.axis.bbox.maxd) * 0.15;
    // Get the x and y translation of the axis center
    // 1.5 of the maximum x,y size of the design
    var size = Math.max(this.design.size.x, this.design.size.y) * 0.5 * 1.5;

    var tr = Sculpteo3DViewerTransform3D.identity;
    tr = tr.scale(scale, scale, scale);
    tr = tr.translate(
      this.design.center.x - size - 1 * scale,
      this.design.center.y - size - 1 * scale,
      this.design.center.z - maxd * 0.5 + 1 * scale
    );
    this.axis.node.setTransform(tr);

    if (!this.axis.visible) {
      this.axis.visible = true;
      this.viewer.getScene().appendChild(this.axis.node);
    }
  };

  /**
   * Activate the print plate
   * Creates the plate node if not created as a bbox
   */
  PrintPartOrientationView.prototype.activatePrintPlate = function () {
    if (this.printPlate.active) {
      return;
    }
    if (!this.printPlate.scene) {
      this.printPlate.scene = true;

      this.printPlate.bottom = this.viewer.createNode("print_plate_bottom");
      this.viewer.createColorCube(1.0, 255, 0, 0, "print_plate_bottom");
      this.printPlate.bottom.setDrawMode(
        Sculpteo3DViewerSceneNode.DRAWMODE_BBOX
      );
      this.printPlate.bottom.setStyle({
        bboxColor: { r: 20, g: 20, b: 20, a: 96 },
      });
    }

    this.printPlate.active = true;
    this.updatePrintPlate();
  };

  /**
   * Deactivates the print plate state and hides it
   */
  PrintPartOrientationView.prototype.deactivatePrintPlate = function () {
    if (!this.printPlate.active) {
      return;
    }

    this.printPlate.active = false;
    this.printPlate.visible = false;
    this.printPlate.bottom.detach();
  };

  /**
   * Update the visibility, position and size of the print plate
   * The size depends on the current design or the batch print plate size
   */
  PrintPartOrientationView.prototype.updatePrintPlate = function () {
    if (!this.printPlate.active) {
      return;
    }

    var sizex, sizey, sizez;
    var tr_x, tr_y, tr_z;
    // Compute design max dimension
    var size = this.design.size;
    var scale = Math.max(size.x, size.y, size.z);

    // Make transform to box on screen center
    var st = new Sculpteo3DViewerTransform3D();

    st = st.scale(scale, scale, scale);
    st = st.translate(
      this.design.center.x,
      this.design.center.y,
      this.design.center.z
    );

    sizex = sizey = Math.max((size.x / scale) * 1.5, (size.y / scale) * 1.5);
    sizez = (size.z / scale) * 0.0001;
    tr_x = 0;
    tr_y = 0;
    tr_z = (-scale * 0.5) / scale;

    var t = new Sculpteo3DViewerTransform3D();
    t = t.scale(sizex, sizey, sizez);
    t = t.translate(tr_x, tr_y, tr_z);
    if (st) {
      t = st.x(t);
    }
    this.printPlate.bottom.setTransform(t);

    if (!this.printPlate.visible) {
      this.printPlate.visible = true;
      this.viewer.getScene().appendChild(this.printPlate.bottom);
    }
  };
})((window.sculpteo = window.sculpteo || {}));
